import { getNameFromUrl, prefixSecondPath } from '../request';
import { regReactPlugin } from './index';

function prefixPath (src: any, publicDomain = '', publicUrl = '') {
  if (!publicDomain && !publicUrl) return false;
  let newValue = src;
  if (newValue && typeof newValue === 'string' && /^\//.test(newValue)) {
    // 处理 api 请求
    if (getNameFromUrl(newValue)) {
      newValue = prefixSecondPath(newValue);
    } else {
      if (newValue.indexOf(publicUrl) !== 0) {
        newValue = `${publicUrl}${newValue}`;
      }
      newValue = `${publicDomain}${newValue}`;
    }
  }
  return newValue;
}

// 处理二级域名和二级路径
export function secondDomainAndPath() {
  regReactPlugin('setAttribute', (o) => {
    const { node, propertyName, attributeName, attributeValue } = o;
    if (!node) return o;
    let publicDomain = '';
    let publicUrl = '';
    if (['IMG', 'VIDEO', 'AUDIO'].includes(node.nodeName) && (propertyName === 'src' || attributeName === 'src')) {
      // img/audio/video  独立的二级域名和二级路径变量
      publicDomain = window['publicDomainfileSource'] || '';
      publicUrl = window['publicUrlfileSource'] || '';
    } else if ((node.nodeName === 'IFRAME' && (propertyName === 'src' || attributeName === 'src')) ||
      (node.nodeName === 'A' && (propertyName === 'href' || attributeName === 'herf'))
    ) {
      // iframe/a  独立的二级域名和二级路径变量
      publicDomain = '';
      publicUrl = window['publicUrllinkOrigin'] || window.publicUrlstatic || window.publicUrl || '';
    }
    const newAttributeValue = prefixPath(attributeValue, publicDomain, publicUrl);
    if (newAttributeValue) {
      o.attributeValue = newAttributeValue;
    } else if(node.nodeName === 'IMG'){
      // 没有newAttributeValue的情况下 并且节点类型为 img的时候需要特殊处理 且存在后端二级路径变量下。
      const publicUrlapi =  window.publicUrlapi || window.publicUrl || '';
      if(publicUrlapi){
        const reg = new RegExp(`^${window.location.origin}/p?api/file`)
        // 全域名 且图片接口为 文档预览接口的情况下
        if(attributeValue.match(reg)){
          const newAttributeValue = attributeValue.replace(window.location.origin, window.location.origin + `${publicUrl}`);
          if (newAttributeValue) {
            o.attributeValue = newAttributeValue;
          }
        } else if(attributeValue.match(/^\/(api|sapi|papi)/)){
          // 非全域名 相对路径的图片资源
          o.attributeValue = publicUrlapi + o.attributeValue;
        }
      }
    }

    return o;
  })
}